module.exports = "<ul><li>flyingoctopus</li><li>Newland Systems</li><li>Rouxbe Cooking School</li><li>Crossfader.fm/DJZ</li><li>Hybridity</li><li>Acqurate</li><li>Coverall Crew</li><li>Blitzoo Games</li><li>Microsoft</li><li>BigPark</li></ul>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/assets/resume.md
 ** module id = 169
 ** module chunks = 0
 **/